"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPlayersSduiResponseDto = instanceOfPlayersSduiResponseDto;
exports.PlayersSduiResponseDtoFromJSON = PlayersSduiResponseDtoFromJSON;
exports.PlayersSduiResponseDtoFromJSONTyped = PlayersSduiResponseDtoFromJSONTyped;
exports.PlayersSduiResponseDtoToJSON = PlayersSduiResponseDtoToJSON;
exports.PlayersSduiResponseDtoToJSONTyped = PlayersSduiResponseDtoToJSONTyped;
var TeamPlayersSduiGroupDto_1 = require("./TeamPlayersSduiGroupDto");
/**
 * Check if a given object implements the PlayersSduiResponseDto interface.
 */
function instanceOfPlayersSduiResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function PlayersSduiResponseDtoFromJSON(json) {
    return PlayersSduiResponseDtoFromJSONTyped(json, false);
}
function PlayersSduiResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (json['data'].map(TeamPlayersSduiGroupDto_1.TeamPlayersSduiGroupDtoFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function PlayersSduiResponseDtoToJSON(json) {
    return PlayersSduiResponseDtoToJSONTyped(json, false);
}
function PlayersSduiResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : (value['data'].map(TeamPlayersSduiGroupDto_1.TeamPlayersSduiGroupDtoToJSON)),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
